import { gql } from '@apollo/client';

export const DOWNLOAD_CAMPAIGN_OFFERS = gql`
  mutation DownloadCampaignOffersFull(
    $input: DownloadCampaignOffersFullInput!
  ) {
    downloadCampaignOffersFull(input: $input) {
      csvUrl
    }
  }
`;

export const APPROVE_CAMPAIGN = gql`
  mutation ApproveCampaign($input: ApproveCampaignInput!) {
    approveCampaign(input: $input) {
      id
      status
      flatFeePerStore
    }
  }
`;

export const APPROVE_DIRECT_BOOKING_CAMPAIGN = gql`
  mutation ApproveDirectBookingCampaign($input: ApproveCampaignInput!) {
    approveDirectBookingCampaign(input: $input) {
      id
      status
      flatFeePerStore
    }
  }
`;

export const DECLINE_CAMPAIGN = gql`
  mutation DeclineCampaign($input: DeclineCampaignInput!) {
    declineCampaign(input: $input) {
      id
      status
    }
  }
`;

export const CREATE_CAMPAIGN_EXAMPLE_FILES = gql`
  mutation CreateCampaignExampleFiles(
    $input: CreateCampaignExampleFilesInput!
  ) {
    createCampaignExampleFiles(input: $input) {
      fields
      key
      url
    }
  }
`;

export const UPDATE_CAMPAIGN = gql`
  mutation UpdateCampaign($input: UpdateCampaignInput!) {
    updateCampaign(input: $input) {
      id
    }
  }
`;

export const UPDATE_BOOK_ME_CAMPAIGN = gql`
  mutation UpdateBookMeCampaign($input: UpdateBookMeCampaignInput!) {
    updateBookMeCampaign(input: $input) {
      id
    }
  }
`;

export const UPDATE_SPONSORED_APPEARANCE_CAMPAIGN = gql`
  mutation UpdateSponsoredAppearanceCampaign(
    $input: UpdateSponsoredAppearanceInput!
  ) {
    updateSponsoredAppearanceCampaign(input: $input) {
      id
    }
  }
`;

export const UPDATE_EVENT_MARKETING_CAMPAIGN = gql`
  mutation UpdateEventMarketingCampaign(
    $input: UpdateEventMarketingCampaignInput!
  ) {
    updateEventMarketingCampaign(input: $input) {
      id
      name
      activities {
        ... on EventMarketingActivity {
          id
          description
          estimatedViews
          participantCount
          shortFormVideoCount
          socialMediaLinks
          sport
          startDate
          type
        }
      }
    }
  }
`;

export const COMPLETE_CAMPAIGN = gql`
  mutation CompleteCampaign($input: CompleteCampaignInput!) {
    completeCampaign(input: $input) {
      id
      status
      type
    }
  }
`;

export const COMPLETED_CAMPAIGN_OFFER = gql`
  mutation CompleteCampaignOffer($input: CompleteCampaignOfferInput!) {
    completeCampaignOffer(input: $input) {
      id
      statusV2
    }
  }
`;

export const ADD_ATHLETE_TO_CAMPAIGN = gql`
  mutation AddAthleteToCampaign($input: AddOfferToCampaignInput!) {
    addOfferToCampaign(input: $input) {
      id
    }
  }
`;

export const CREATE_CAMPAIGN_SUBMISSION_FILES = gql`
  mutation CreateCampaignSubmissionFiles(
    $input: CreateCampaignSubmissionFilesInput!
  ) {
    createCampaignSubmissionFiles(input: $input) {
      fields
      key
      url
    }
  }
`;

export const SUBMIT_CAMPAIGN_OFFER_RESULTS = gql`
  mutation SubmitCampaignOfferResults(
    $input: SubmitCampaignOfferResultsInput!
  ) {
    submitCampaignOfferResults(input: $input) {
      id
      statusV2
      submissions {
        id
        type
        ... on CampaignIGLiveSubmission {
          imageKey
          url
        }
        ... on CampaignIGPostSubmission {
          link
        }
        ... on CampaignIGReelSubmission {
          link
        }
        ... on CampaignIGStorySubmission {
          imageKey
          url
        }
        ... on CampaignTTVideoSubmission {
          link
        }
        ... on CampaignTWTweetSubmission {
          link
        }
        ... on CampaignTWVideoSubmission {
          link
        }
        ... on CampaignTWLiveSubmission {
          link
        }
      }
    }
  }
`;

export const SUBMIT_CAMPAIGN_OFFER_RESULTS_V2 = gql`
  mutation SubmitCampaignOfferResultsV2(
    $input: SubmitCampaignOfferResultsInput!
  ) {
    submitCampaignOfferResultsV2(input: $input) {
      id
      statusV2
      submissions {
        id
        type
        ... on CampaignIGLiveSubmission {
          imageKey
          url
        }
        ... on CampaignIGPostSubmission {
          igPostLink: link
        }
        ... on CampaignIGReelSubmission {
          igReelLink: link
        }
        ... on CampaignIGStorySubmission {
          imageKey
          url
        }
        ... on CampaignTTVideoSubmission {
          ttVideoLink: link
        }
        ... on CampaignTWLiveSubmission {
          twLiveLink: link
        }
        ... on CampaignTWTweetSubmission {
          twTweetLink: link
        }
        ... on CampaignTWVideoSubmission {
          twVideoLink: link
        }
        ... on CampaignTTShareSubmission {
          link
          ttShareImageKey: imageKey
          ttUrl: url
        }
        ... on CampaignIGShareSubmission {
          link
          igShareImageKey: imageKey
          igShareUrl: url
        }
        ... on CampaignTWShareSubmission {
          link
          twShareImageKey: imageKey
          twUrl: url
        }
      }
    }
  }
`;

export const CREATE_SPONSORED_APPEARANCE_IMAGE = gql`
  mutation CreateSponsoredAppearanceImage($input: CreateStreamImageInput!) {
    createStreamImage(input: $input) {
      fields
      key
      url
    }
  }
`;

export const INIT_STREAM_MULTIPART_UPLOAD = gql`
  mutation InitStreamMultipartUpload($input: InitStreamMultipartUploadInput!) {
    initStreamMultipartUpload(input: $input) {
      fileId
      fileKey
      signedUrls {
        partNumber
        signedUrl
      }
    }
  }
`;

export const COMPLETE_STREAM_MULTIPART_UPLOAD = gql`
  mutation CompleteStreamMultipartUpload(
    $input: CompleteMultipartUploadInput!
  ) {
    completeStreamMultipartUpload(input: $input)
  }
`;

export const SUBMIT_PAST_APPEARANCE_STREAM = gql`
  mutation SubmitPastAppearanceStream(
    $input: CreatePastAppearanceStreamInput!
  ) {
    submitPastAppearanceStream(input: $input) {
      id
    }
  }
`;

export const UPDATE_CAMPAIGN_OWNERSHIP = gql`
  mutation UpdateCampaignOwnership($input: UpdateCampaignOwnershipInput!) {
    updateCampaignOwnership(input: $input) {
      id
    }
  }
`;

export const UPDATE_SOCIAL_SHARE_CAMPAIGN = gql`
  mutation UpdateSocialShareCampaign($input: UpdateSocialShareCampaignInput!) {
    updateSocialShareCampaign(input: $input) {
      id
      name
      status
      activities {
        ... on SocialShareActivity {
          id
          brandName
          instructions
          shareUrl
          tasks {
            id
            type
          }
          type
        }
      }
      budget
      budgetLeft
      createdAt
      dueDate
      flatFeePerStore
    }
  }
`;

export const UPDATE_SOCIAL_BOOST_CAMPAIGN = gql`
  mutation UpdateSocialBoostCampaign($input: UpdateSocialBoostCampaignInput!) {
    updateSocialBoostCampaign(input: $input) {
      id
      name
      status
      activities {
        ... on SocialBoostActivity {
          id
          brandName
          postUrl
          caption
          tags
          website
          type
        }
      }
      budget
      budgetLeft
      createdAt
      dueDate
      flatFeePerStore
    }
  }
`;

export const CREATE_CAMPAIGN_DELIVERABLES_FILES = gql`
  mutation CreateCampaignDeliverableFiles(
    $input: CreateDeliverableFilesInput!
  ) {
    createCampaignDeliverableFiles(input: $input) {
      key
      url
      fields
    }
  }
`;

export const DUPLICATE_CAMPAIGN = gql`
  mutation DuplicateCampaign($input: DuplicateCampaignInput!) {
    duplicateCampaign(input: $input) {
      id
    }
  }
`;

export const SUBMIT_DELIVERABLES_FOR_REVIEW = gql`
  mutation SubmitDeliverablesForReview(
    $input: SubmitCampaignDeliverablesForReviewInput!
  ) {
    submitDeliverablesForReview(input: $input) {
      id
      statusV2
    }
  }
`;

export const SUBMIT_DELIVERABLES_FOR_REVIEW_V2 = gql`
  mutation SubmitDeliverablesForReviewV2(
    $input: SubmitCampaignDeliverablesForReviewV2Input!
  ) {
    submitDeliverablesForReviewV2(input: $input) {
      id
      statusV2
      deliverablesV2 {
        id
        status
        updatedAt
        items {
          id
          type
          status
        }
      }
    }
  }
`;

export const APPROVE_DELIVERABLES = gql`
  mutation ApproveDeliverables($input: ApproveDeliverableInput!) {
    approveDeliverables(input: $input) {
      deliverables {
        agencyFeedback
        createdAt
        id
        postCopy
        status
      }
    }
  }
`;

export const REJECT_DELIVERABLES = gql`
  mutation RejectDeliverables($input: RejectDeliverableInput!) {
    rejectDeliverables(input: $input) {
      deliverables {
        agencyFeedback
        createdAt
        id
        postCopy
        status
      }
    }
  }
`;

export const CREATE_CAMPAIGN_COLLAB_INVITE = gql`
  mutation CreateCampaignCollabInvite(
    $input: CreateCampaignCollabInviteInput!
  ) {
    createCampaignCollabInvite(input: $input) {
      invite
      roleId
    }
  }
`;

export const UPDATE_CAMPAIGN_COLLAB_ROLE = gql`
  mutation UpdateCampaignCollabRole($input: UpdateCampaignCollabRoleInput!) {
    updateCampaignCollabRole(input: $input) {
      role {
        roleId
        permissions {
          name
        }
      }
    }
  }
`;

export const REMOVE_CAMPAIGN_COLLAB = gql`
  mutation RemoveCampaignCollab($input: RemoveCampaignCollabInput!) {
    removeCampaignCollab(input: $input)
  }
`;

export const REMOVE_OFFER_FROM_CAMPAIGN = gql`
  mutation RemoveOfferFromCampaign($input: RemoveOfferFromCampaignInput!) {
    removeOfferFromCampaign(input: $input)
  }
`;

export const SEND_CAMPAIGN_COLLAB_INVITE = gql`
  mutation SendCampaignCollabInvite($input: SendCampaignCollabInviteInput!) {
    sendCampaignCollabInvite(input: $input) {
      invite
      roleId
    }
  }
`;

export const EDIT_CAMPAIGN_SETTINGS = gql`
  mutation EditCampaignSettings($input: EditCampaignSettingsInput!) {
    editCampaignSettings(input: $input) {
      id
      launchFee
      platformMarginPercent
      inviteProcessingFee
      requiresAgreement
    }
  }
`;

export const EDIT_CAMPAIGN_CONTENT = gql`
  mutation EditCampaignContent($input: EditCampaignContentInput!) {
    editCampaignContent(input: $input) {
      id
    }
  }
`;

export const UNWAIVE_CAMPAIGN_FEE = gql`
  mutation UnwaiveLaunchFee($input: UnwaiveLaunchFeeInput!) {
    unwaiveLaunchFee(input: $input) {
      id
      launchFee
    }
  }
`;

export const UPDATE_CB_APPLICATION_ANSWER = gql`
  mutation UpdateCbApplicationAnswer($input: UpdateCbApplicationAnswerInput!) {
    updateCbApplicationAnswer(input: $input) {
      id
      answer
      originalAnswer
      question {
        id
        isRequired
        order
        type
        question
      }
    }
  }
`;

export const DELETE_CAMPAIGN = gql`
  mutation DeleteCampaign($input: DeleteCampaignInput!) {
    deleteCampaign(input: $input) {
      id
    }
  }
`;

export const TAKE_CAMPAIGN_LOCK = gql`
  mutation TakeCampaignLock($input: TakeCampaignLockInput!) {
    takeCampaignLock(input: $input) {
      id
    }
  }
`;

export const RELEASE_CAMPAIGN_LOCK = gql`
  mutation ReleaseCampaignLock($input: ReleaseCampaignLockInput!) {
    releaseCampaignLock(input: $input)
  }
`;

export const UPDATE_UGC_CAMPAIGN = gql`
  mutation UpdateUgcCampaign($input: UpdateUgcCampaignInput!) {
    updateUgcCampaign(input: $input) {
      id
    }
  }
`;

export const UPDATE_CUSTOM_CAMPAIGN = gql`
  mutation UpdateCustomCampaign($input: UpdateCustomCampaignInput!) {
    updateCustomCampaign(input: $input) {
      id
      name
      status
      type
      isPrivate
      usageRights
      usageRightsText
      usageRightsDuration {
        years
        months
      }
      usageRightsScopes
      flatFeePerStore
      budget
      budgetLeft
      totalAthletes
      totalCost
      totalFollowers
      applicationDeadlineDays
      agency {
        id
      }
      activities {
        ... on CustomBriefActivity {
          id
          type
          instructions
          brandName
          website
          encouraged
          avoid
          physicalProduct
          productValue
          products {
            name
            description
            cost
            qty
            shipping
          }
          promoCodes
          promoUrls
          contracts {
            key
            url
            kind
          }
          tasksV2 {
            id
            type
            title
            description
            hashtags
            mentions
            tagAsCollab
            contentItems {
              id
              type
              title
              description
              orderIdx
              ... on CampaignContentTask {
                mediaType
              }
            }
          }
        }
      }
      questions {
        id
        question
        type
      }
      search {
        ... on CustomSearchCriteria {
          id
          flatFeePerStore
          excludeWorkedWith
          excludeDeclined
          platformCriteria {
            platform
            minFollowers
            maxFollowers
            minEngagementRate
            maxEngagementRate
          }
        }
      }
    }
  }
`;

export const UPDATE_DIRECT_BOOKING_CAMPAIGN = gql`
  mutation UpdateDirectBookingCampaign(
    $input: UpdateDirectBookingCampaignInput!
  ) {
    updateDirectBookingCampaign(input: $input) {
      id
      name
      status
      type
      isPrivate
      usageRights
      usageRightsText
      usageRightsDuration {
        years
        months
      }
      usageRightsScopes
      flatFeePerStore
      estimatedBudget
      budget
      budgetLeft
      totalAthletes
      totalCost
      totalFollowers
      applicationDeadlineDays
      agency {
        id
      }
      activities {
        ... on CustomBriefActivity {
          id
          type
          instructions
          brandName
          website
          encouraged
          avoid
          physicalProduct
          productValue
          products {
            name
            description
            cost
            qty
            shipping
          }
          promoCodes
          promoUrls
          contracts {
            key
            url
            kind
          }
          tasksV2 {
            id
            type
            title
            description
            hashtags
            mentions
            tagAsCollab
            contentItems {
              id
              type
              title
              description
              orderIdx
              ... on CampaignContentTask {
                mediaType
              }
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_CAMPAIGN_DEADLINES = gql`
  mutation UpdateCampaignDeadlines($input: UpdateCampaignDeadlinesInput!) {
    updateCampaignDeadlines(input: $input) {
      id
    }
  }
`;

export const REVIEW_DELIVERABLES = gql`
  mutation ReviewDeliverables($input: ReviewDeliverablesInput!) {
    reviewDeliverables(input: $input) {
      id
      statusV2
      attention
    }
  }
`;

export const REQUEST_CB_TASK_EXTENSION = gql`
  mutation RequestCbTaskExtension($input: RequestCbTaskExtensionInput!) {
    requestCbTaskExtension(input: $input) {
      id
    }
  }
`;

export const APPROVE_TASK_EXTENSION = gql`
  mutation ApproveCbTaskExtension($input: ApproveCbTaskExtensionInput!) {
    approveCbTaskExtension(input: $input) {
      id
      type
      status
      reason
      requestedExtensionDays
      createdAt
      updatedAt
      reviewedAt
      reviewedBy {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export const REJECT_TASK_EXTENSION = gql`
  mutation RejectCbTaskExtension($input: RejectCbTaskExtensionInput!) {
    rejectCbTaskExtension(input: $input) {
      id
      type
      status
      reason
      requestedExtensionDays
      createdAt
      updatedAt
      reviewedAt
      reviewedBy {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export const INIT_DELIVERABLE_FILE_MULTIPART_UPLOAD = gql`
  mutation InitDeliverableFileMultipartUpload(
    $input: InitDeliverableFileMultipartUploadInput!
  ) {
    initDeliverableFileMultipartUpload(input: $input) {
      fileId
      fileKey
      signedUrls {
        partNumber
        signedUrl
      }
    }
  }
`;

export const COMPLETE_DELIVERABLE_FILE_MULTIPART_UPLOAD = gql`
  mutation CompleteDeliverableFileMultipartUpload(
    $input: CompleteMultipartUploadInput!
  ) {
    completeDeliverableFileMultipartUpload(input: $input) {
      convertJobId
    }
  }
`;

export const APPROVE_SOCIAL_BOOST_CAMPAIGN = gql`
  mutation ApproveSocialBoostCampaign(
    $input: ApproveSocialBoostCampaignInput!
  ) {
    approveSocialBoostCampaign(input: $input) {
      id
      status
      flatFeePerStore
    }
  }
`;

export const RESOLVE_SOCIAL_BOOST_DISPUTE = gql`
  mutation ResolveSocialBoostDispute($input: ResolveSocialBoostDisputeInput!) {
    resolveSocialBoostDispute(input: $input) {
      id
      statusV2
    }
  }
`;

export const REINSTATE_SOCIAL_BOOST_OFFER = gql`
  mutation ReinstateSocialBoostOffer($input: ReinstateSocialBoostOfferInput!) {
    reinstateSocialBoostOffer(input: $input) {
      id
      statusV2
    }
  }
`;

export const CLAIM_SOCIAL_BOOST_OFFER = gql`
  mutation ClaimSocialBoostOffer($input: ClaimSocialBoostOfferInput!) {
    claimSocialBoostOffer(input: $input) {
      id
      statusV2
    }
  }
`;

export const DECLINE_SOCIAL_BOOST_OFFER = gql`
  mutation DeclineSocialBoostOffer($input: DeclineSocialBoostOfferInput!) {
    declineSocialBoostOffer(input: $input) {
      id
      statusV2
    }
  }
`;

export const SET_CAMPAIGN_AGREEMENT_SIGNATORY = gql`
  mutation SetCampaignAgreementSignatory(
    $input: SetCampaignAgreementSignatoryInput!
  ) {
    setCampaignAgreementSignatory(input: $input) {
      id
      agreementSignatoryId
    }
  }
`;

export const REPLACE_CAMPAIGN_SUBMISSION_LINK = gql`
  mutation ReplaceCampaignSubmissionLink(
    $input: ReplaceCampaignSubmissionLinkInput!
  ) {
    replaceCampaignSubmissionLink(input: $input) {
      id
      type
      ... on CampaignIGPostSubmission {
        link
      }
      ... on CampaignIGReelSubmission {
        link
      }
      ... on CampaignTTVideoSubmission {
        link
      }
      ... on CampaignTWTweetSubmission {
        link
      }
      ... on CampaignTWVideoSubmission {
        link
      }
      ... on CampaignTWLiveSubmission {
        link
      }
    }
  }
`;
